// extracted by mini-css-extract-plugin
export default {"tipeMakananChoosed":"TappingAdmin_tipeMakananChoosed__yqkq9","tipeMakananNotChoosed":"TappingAdmin_tipeMakananNotChoosed__xJn7o"};